import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GradientButton } from '../../components/Buttons';
import {
  IconArrowRight,
  IconBook,
  IconCreditCard,
  IconKey,
  IconRosetteDiscountCheck,
  IconSparkles,
} from '@tabler/icons-react';
import { Footer } from '../../components/Footer';
import { PRICING_MATRIX } from '../../constants/billing';

function Pricing() {
  useEffect(() => {
    document.title = 'Pricing | PromptSlate';
  }, []);

  let [billMonthly, setBillMonthly] = useState<boolean>(false);

  return (
    <div className="flex flex-col w-full items-center h-fit">
      <div className="w-full h-[45px] flex justify-center border-b">
        <div className="w-full max-w-5xl h-full flex items-center justify-between text-sm">
          <div>Introducting PromptSlate</div>
          <Link to="/signup">
            <div className="flex flex-row">
              Get started now <IconSparkles size="1rem" className="ml-2 mt-0.5" />
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full max-w-5xl mt-2 mb-12">
        <div className="w-full max-w-5xl h-[70px] flex items-center justify-between">
          <div>
            <Link to="/">
              <img
                src="/logo_black.png"
                alt="PromptSlate logo"
                className="h-[30px] object-contain"
              />
            </Link>
          </div>
          <div className="flex flex-row">
            <div className="flex flex-row mr-5 p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
              <IconBook size="1.5rem" className="mr-1" /> Docs
            </div>
            <div className="flex flex-row mr-4 p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
              <IconCreditCard size="1.5rem" className="mr-1" /> Pricing
            </div>
            <Link to="/login">
              <div className="flex flex-row p-2 rounded-lg hover:bg-slate-100 cursor-pointer duration-100 ease-in-out">
                <IconKey size="1.5rem" className="mr-1" /> Login
              </div>
            </Link>
          </div>
        </div>
        <div className="mt-12">
          <div className="max-w-[50%] text-5xl font-semibold leading-[55px]">
            PromptSlate Pricing
          </div>
          <div className="flex flex-row gap-6 mt-8 font-semibold">
            <span
              className={`cursor-pointer ${billMonthly ? 'text-slate-800' : 'text-slate-400'}`}
              onClick={() => setBillMonthly(true)}
            >
              Monthly
            </span>
            <span
              className={`cursor-pointer ${billMonthly ? 'text-slate-400' : 'text-slate-800'}`}
              onClick={() => setBillMonthly(false)}
            >
              Annualy
            </span>
          </div>
          <div className="flex flex-row gap-5 mt-3">
            {PRICING_MATRIX.map((pricing) => (
              <div
                key={pricing.title}
                className="flex-1 min-h-[300px] border border-slate-200 rounded-xl p-8"
              >
                <span className="text-2xl font-semibold">{pricing.title} </span>
                <div className="w-3/4">
                  <span className="text-slate-500 text-sm">{pricing.currency} </span>
                  <span className="text-2xl font-semibold">
                    {billMonthly
                      ? pricing.pricing.monthly.pricePerMonth
                      : pricing.pricing.annualy.pricePerMonth}{' '}
                  </span>
                  <span className="text-lg text-slate-500">
                    per month billed {billMonthly ? 'monthly' : 'annualy'}
                  </span>
                </div>
                <div className="flex flex-col mt-4">
                  {pricing.features.map((feature) => (
                    <div key={feature} className="flex flex-row text-lg">
                      <IconRosetteDiscountCheck size="1rem" className="mr-1 mt-1.5" /> {feature}
                    </div>
                  ))}
                </div>
                <Link to="/settings/billing">
                  <GradientButton className="hover:shadow-xl transition-all duration-300 ease-in-out mt-12">
                    <div className="flex flex-row text-lg">
                      Choose {pricing.title}
                      <IconArrowRight size="1.5rem" className="ml-2 mt-0.5" />
                    </div>
                  </GradientButton>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-full h-[400px] border-t mt-12 flex flex-col justify-center items-center">
        <div className="flex flex-row max-w-5xl justify-between">
          <div className="max-w-[45%]">
            <div>
              <img
                src="/logo_black.png"
                alt="PromptSlate logo"
                className="h-[40px] object-contain"
              />
            </div>
            <div className=" text-5xl font-semibold leading-[55px] mt-12">
              Supercharge Your Workflow by managing prompts like a pro today
            </div>
          </div>
          <div className="flex items-center">
            <Link to="/signup">
              <GradientButton className="h-[55px] hover:shadow-xl transition-all duration-300 ease-in-out">
                <div className="flex flex-row text-lg">
                  Get started now <IconArrowRight size="1.5rem" className="ml-2 mt-0.5" />
                </div>
              </GradientButton>
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Pricing;
